// UX105: display names for the recipe editor, kept out of admin.ts so a plain node test can import them.

/** UX105: a stored component reference that is a slug ("lime-juice", "simple_syrup") reads as a name ("Lime juice").
 * A reference with capitals or spaces is already a name and is shown as stored. */
export function humanizeComponentReference(reference: string): string {
  if (!/^[a-z0-9]+([-_][a-z0-9]+)+$/.test(reference)) return reference;
  const words = reference.replace(/[-_]/g, " ");
  return words.charAt(0).toUpperCase() + words.slice(1);
}
